import styled from '@emotion/styled'

export const StyledCustomers = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`